var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-item__details" },
    [
      _c(
        "div",
        { staticClass: "product-item__title-wrapper d-flex justify-between" },
        [
          _c(
            "a",
            {
              staticClass: "product-item__title body-base no-underline",
              attrs: { href: _vm.product.context_url }
            },
            [_vm._v(_vm._s(_vm.product.title))]
          )
        ]
      ),
      _vm._v(" "),
      _c("ProductCardPrice", { attrs: { data: _vm.priceData } }),
      _vm._v(" "),
      _c("div", [
        _c("dd", { staticClass: "swym-plp" }, [
          _c("button", {
            class:
              "swym-button swym-add-to-wishlist-view-product product_" +
              this.product.id,
            attrs: {
              "data-with-epi": "true",
              "data-swaction": "addToWishlist",
              "data-product-id": this.product.id,
              "data-variant-id": this.product.variants[0].id,
              "data-product-url":
                "https://francesvalentine.com/products/" + this.product.handle
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("ProductCardSwatches", { attrs: { data: _vm.swatchesData } }),
      _vm._v(" "),
      _c("div", {
        staticClass: "yotpo bottomLine",
        attrs: { "data-product-id": _vm.product.id }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }